
<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="changeDialog()" small color="white" class="primary mx-5 py-3" v-bind="attrs" v-on="on">
          <div class="d-flex flex-column">
            <span>{{ kind[remove].text }}</span>
            <span>Paletes</span>
          </div>
          <v-icon class="ml-2" size="20">{{kind[remove].icon}}</v-icon>
        </v-btn>
      </template>
      <span>{{ kind[remove].text }} Paletes</span>
    </v-tooltip>
    <v-dialog 
      v-model="dialog" 
      persistent 
      :overlay="true" 
      max-width="600px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title>
          <span class="headline">{{ kind[remove].text }} Paletes</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-autocomplete
              v-model="selected_employee_id"
              :items="employees"
              item-text="name"
              item-value="id"
              label="Vendedor"
              prepend-icon="mdi-account"
              :rules="required"
              :loading="loading_employees"
              clearable
            >
              <template v-slot:no-data>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title>Nenhum vendedor encontrado</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>
            </v-autocomplete>
            
            <v-text-field 
              :rules="[...required, ...positive_number, ...integerOnly]" 
              label="Quantidade de Paletes" 
              v-model="quantity_of_pallets" 
              type="number"
            ></v-text-field>
            <v-textarea label="Comentário" v-model="comment"></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn close @click="changeDialog()">Cancelar</f-btn>
          <f-btn save @click="createPalletsHistory">Salvar</f-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import Api from '@/api/index';
import validations from '@/mixins/validations.js'

export default {
  name: 'BtnEditPallets',
  mixins: [
    validations
  ],
  props: {
    pickup_location_id: {
      type: [Number, String],
    },
    remove: {
      type: Boolean,
      required: false,
    },
    default_employee_id: {
      type: [Number, String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      dialog: false,
      saving: false,
      quantity_of_pallets: 0,
      comment: '',
      selected_employee_id: null,
      employees: [],
      loading_employees: false,
      kind: {
        true: { text: "Remover", icon:"mdi-minus", enum: "exit"},
        false: { text: "Adicionar", icon:"mdi-plus", enum: "entry"},
      }
    }
  },
  methods: {
    changeDialog(){
      this.dialog = !this.dialog
      if (this.dialog) {
        this.getEmployees()
        // Se houver um vendedor selecionado no filtro, pré-seleciona ele
        if (this.default_employee_id) {
          this.selected_employee_id = parseInt(this.default_employee_id)
        }
      } else {
        this.resetForm()
      }
    },
    resetForm() {
      this.quantity_of_pallets = 0
      this.comment = ''
      this.selected_employee_id = null
    },
    getEmployees() {
      this.loading_employees = true
      let params = {
        short: true,
        by_roles: ["Manager", "Seller"],
      }
      Api.Employee.index(params).then(r => r.data).then(employees => {
        this.employees = employees.data.map(e => ({
          id: parseInt(e.id),
          name: e.attributes.name || e.attributes.user_name || e.attributes.employee_name
        }))
      }).catch(err => {
        console.error(err)
        this.addNotification({type: 'error', msg: 'Erro ao carregar vendedores'})
      }).finally(() => {
        this.loading_employees = false
      })
    },
    createPalletsHistory() {
      if(this.$refs.form.validate()){
        this.saving = true
        let pallets_history = {
          pickup_location_id: this.pickup_location_id,
          employee_id: this.selected_employee_id,
          quantity: this.quantity_of_pallets,
          kind: this.kind[this.remove].enum,
          comment: this.comment
        }
        Api.PalletsHistory.create(pallets_history).then(r=> r.data).then(d=> {
          this.successUpdated()
          this.$emit('updated', 'pickup_location')
        }).catch(err=>{
          console.log(err)
          this.errorUpdated()
        }).finally(() => {
          this.saving = false
          this.changeDialog()
        })
      }
    },
  },
}
</script>